import React from 'react';
import { useReveal } from './useReveal';

export default function Reveal({ as: Tag = 'div', className = '', delay = 0, children, ...rest }) {
    const [ref, visible] = useReveal();
    return (
        <Tag
            ref={ref}
            className={`lp-reveal ${visible ? 'is-visible' : ''} ${className}`}
            style={delay ? { transitionDelay: `${delay}ms` } : undefined}
            {...rest}
        >
            {children}
        </Tag>
    );
}
